var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Sniffer"},[_c('div',{staticClass:"Sniffer__content"},[_c('div',{staticClass:"Sniffer__bar"}),_vm._v(" "),_c('div',{staticClass:"Sniffer__browser"},[_vm._v("\n      "+_vm._s(_vm.trans('browser'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"Sniffer__update"},[_vm._v("\n      "+_vm._s(_vm.trans('update'))+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1924468b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sniffer/Sniffer.vue
// module id = null
// module chunks = 